import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: ${props => props.paddingBottom || 0};
  padding-top: ${props => props.paddingTop || 0};
`;

export const Container = styled.div`
  display: flex;
  padding: 16px;
`;

export const TabContentContainer = styled.div`
  display: flex;
  align-items: space-between;
  padding: 12px 12px 30px 12px;
  flex-direction: column;
`;

export const ErrorMessage = styled.div`
  color: red;
  display: ${props => (props.visible ? 'block' : 'none')};
  position: fixed;
  left: 0.75rem;
  bottom: 1rem;
  z-index: 2;
`;

export const NoteMessage = styled.div`
  color: gray;
  display: ${props => (props.visible ? 'block' : 'none')};
  padding-top: 8px;
  z-index: 2;
`;



// WEBPACK FOOTER //
// ./app/components/RenderMediaDialog/styled-components.js